import {
  faCheck,
  faSpinner,
  faTriangleExclamation,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { RightArrow } from "shared/ui/icons/RightArrow";

import { AnimatePresence, motion } from "framer-motion";

const iconVariants = {
  hidden: { opacity: 0, transition: { ease: "easeInOut" } },
  visible: { opacity: 1, transition: { ease: "easeInOut" } },
  exit: { opacity: 0, transition: { ease: "easeInOut" } },
};

type Status = { status: "loading" | "success" | "error" | "idle" };
export const RequestStateIcons = ({ status }: Status) => {
  return (
    <AnimatePresence mode="wait" initial={false}>
      {status === "loading" && (
        <motion.span
          key="spinner"
          initial="hidden"
          animate="visible"
          exit="exit"
          variants={iconVariants}
        >
          <FontAwesomeIcon icon={faSpinner} className="gg-animate-spin" />
        </motion.span>
      )}
      {status === "success" && (
        <motion.span
          key="success"
          initial="hidden"
          animate="visible"
          exit="exit"
          variants={iconVariants}
        >
          <FontAwesomeIcon icon={faCheck} />
        </motion.span>
      )}
      {status === "error" && (
        <motion.span
          key="error"
          initial="hidden"
          animate="visible"
          exit="exit"
          variants={iconVariants}
        >
          <FontAwesomeIcon icon={faTriangleExclamation} />
        </motion.span>
      )}
      {status !== "loading" && status !== "error" && status !== "success" && (
        <motion.span
          key="default"
          initial="hidden"
          animate="visible"
          exit="exit"
          variants={iconVariants}
        >
          <RightArrow />
        </motion.span>
      )}
    </AnimatePresence>
  );
};
